import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {FieldErrors, UseFormSetValue, UseFormWatch} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import HintQuestion from 'shared/ui/Hint/HintQuestion';

import {useIsFreeTariff, userSelector} from 'entities/user';
import {isTranslate} from 'shared/lib/lang';

import CheckingIntervalSlider from './CheckingIntervalSlider';

import styles from './CheckInterval.module.scss';

interface ICheckIntervalProps {
    item: {check_interval?: number} | undefined;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    errors: FieldErrors<any>;
}

const CheckInterval: React.FC<ICheckIntervalProps> = ({errors, item, setValue, watch}) => {
    const user = useSelector(userSelector);
    const freeTariff = useIsFreeTariff();
    const checkInterval = watch('check_interval', item?.check_interval ?? 5);

    const formatInterval = (value: number) => {
        return value < 60 ? `${value} ${t`м`}.` : `${Math.floor(value / 60)} ${t`ч`}.`;
    };

    return (
        <div className={styles.container}>
            <div className={styles.label}>
                <Trans id="CheckInterval.title" message="Интервал проверки"/>: {formatInterval(checkInterval)}
            </div>
            <div className={styles.containerSlider}>
                {
                    freeTariff &&
                    <div className={styles.baseInterval}>
                        1 {t`м`}
                        <HintQuestion placement="top-start">
                            <>
                                {t`Доступно на тарифах от 100 рублей в месяц.`}
                                { !isTranslate() &&
                                    <a
                                        href={AppUrls.TARIFFS}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {' '}{t`Подключить`}
                                    </a>
                                }
                            </>
                        </HintQuestion>
                    </div>
                }
                <FormGroupWithError
                    error={errors?.check_interval?.message}
                    className={styles.formGroup}
                >
                    <CheckingIntervalSlider
                        name="check_interval"
                        setValue={setValue}
                        minimalValue={user?.tariff?.monitor_min_check_interval_limit ?? 5}
                        defaultValue={item?.check_interval ?? 5}
                        user={user}
                    />
                </FormGroupWithError>
            </div>
        </div>
    );
};

export default CheckInterval;